import React, { useState, useEffect, useRef } from 'react';
import '../Components/ComponentCss/RoomsTabs.css'; // CSS 파일 임포트

// 아니 이걸.........................;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
// 자식에서 상태를 파면 어떻게.....................
// 부모가 rerender trigger 걸릴려면 또 state 덕지덕지해야하는데요???

const RoomTabs = ({
    rooms,
    onSelect,
    selectedRoom,
}) => {
    // 선택된 탭 상태와 인디케이터 스타일 상태
    const [indicatorStyle, setIndicatorStyle] = useState({});
    const tabsRef = useRef([]); // 각 탭 요소를 참조하는 배열

    useEffect(() => {
        // 초기 렌더링 후 첫 번째 탭의 인디케이터 설정
        if (tabsRef.current[0]) {
            updateIndicator(0);
        }
    }, [ rooms ]);

    const handleTabSelect = (tabName, index) => {
        onSelect(tabName);
        updateIndicator(index);
    };

    const updateIndicator = (index) => {
        const tabElement = tabsRef.current[index];
        if (tabElement) {
            setIndicatorStyle({
                width: `${tabElement.offsetWidth}px`,
                left: `${tabElement.offsetLeft}px`,
            });
        }
    };

    return (
        <div className="tabs-container">
            <div className="tabs">
                {rooms.map((room, index) => (
                    <div
                        key={room}
                        ref={(el) => (tabsRef.current[index] = el)} // 각 탭 요소를 ref에 저장
                        className={`tab${selectedRoom === room ? ' active' : ''}`}
                        onClick={() => handleTabSelect(room, index)}
                    >
                        {room}호
                    </div>
                ))}
                <div className="indicator" style={indicatorStyle}></div>
            </div>
        </div>
    );
};

export default RoomTabs;
